import React, { useEffect, useState } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import _ from "lodash";
import { uuid } from "./util";
const ResponsiveReactGridLayout = WidthProvider(Responsive);

/**
 * This layout demonstrates how to use a grid with a dynamic number of elements.
 */
export default function RedQuickOrderedList(props: {
    createElement?: (el: any) => any,
    onChange: (items: any) => void,
    className?: string,
    value: any[],
    cols?: { lg: number, md: number, sm: number, xs: number, xxs: number },
    rowHeight?: number,
    contextId?: string,
    horizontal?: boolean,
    itemProperties?: any;
    preventCollision?: any;
}) {
    let default_prop_valus = {
        className: "layout",
        cols: { lg: 1, md: 1, sm: 1, xs: 1, xxs: 1 },
        rowHeight: 100
    };
    const [items, setItems] = useState([])
    const [breakpoint, setBreakingPoint] = useState(null)
    const [cols, setCols] = useState(props.cols || default_prop_valus.cols)
    const [layout, setLayoutChange] = useState([])
    useEffect(() => {
        if (props.horizontal) {
            setCols({ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 });
        }
    }, [props.horizontal])
    useEffect(() => {
        if (Array.isArray(props.value)) {
            let contextId = props.contextId || uuid();
            let new_items = props.value.filter(x => x).map((item, index) => {
                if (props.horizontal) {
                    return {
                        i: item.id + '#' + contextId + props.value.length,
                        y: Math.floor(index / 12),
                        x: index - (Math.floor(index / 12) * 12), // puts it at the bottom
                        w: 1,
                        h: 1,
                        ...(props.itemProperties || {})
                    }
                }
                return {
                    i: item.id + '#' + contextId + props.value.length,
                    x: 0,
                    y: index, // puts it at the bottom
                    w: 2,
                    h: 1
                }
            });
            setItems(new_items)

            setLayoutChange(new_items);
        }
    }, [JSON.stringify((props.value || []).filter(x => x).map(v => v.id)), (props.value || []).filter(x => x).length])
    function createElement(el: any): any {
        const removeStyle = {
            position: "absolute",
            right: 2,
            top: 0,
            cursor: "pointer"
        };
        const i = el.add ? "+" : el.i;
        if (props.createElement) {
            return <div key={i} data-grid={el}>
                {props.createElement({
                    ...el,
                    i: el.i.split('#')[0]
                })}</div>;
        }
        return (
            <div key={i} data-grid={el}>
                {el.add ? (
                    <span
                        className="add text"

                        title="You can add an item by clicking here, too."
                    >
                        Add +
                    </span>
                ) : (
                    <span className="text">{i}</span>
                )}
                <span
                    className="remove"
                    style={removeStyle}
                >
                    x
                </span>
            </div>
        );
    }

    // We're using the cols coming back from this to calculate where to add new items.
    function onBreakpointChange(breakpoint: any, cols: any) {
        setBreakingPoint(breakpoint);
    }

    function onLayoutChange(layout) {
        if (props.onChange) {
            props.onChange(layout.sort((a, b) => {
                return a.y - b.y;
            }).map(t => {
                return {
                    ...t,
                    i: t.i.split('#')[0]
                }
            }));
        }
        setLayoutChange(layout);
    }
    console.log(cols);
    return (
        <div className="red-quick-ordered-list">
            <ResponsiveReactGridLayout
                onLayoutChange={onLayoutChange}
                onBreakpointChange={onBreakpointChange}
                layout={props.className || default_prop_valus.className}
                cols={cols}
                preventCollision={props.preventCollision}
                compactType={!!props.horizontal ? 'horizontal' : 'vertical'}
                rowHeight={props.rowHeight || 100}
            >
                {items.map(createElement)}
            </ResponsiveReactGridLayout>
        </div>
    );
}